import {
  Component,
  OnInit,
  Inject,
  ChangeDetectionStrategy
} from '@angular/core';
import { DialogRef } from '../../dialog-ref';
import { DIALOG_DATA } from '../../dialog.service';

export interface DialogAlert {
  title?: string;
  description?: string;
  button?: string | null;
}

@Component({
  selector: 'sc-dialog-alert',
  templateUrl: './dialog-alert.component.html',
  styleUrls: ['./dialog-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogAlertComponent implements OnInit {
  constructor(
    public dialogRef: DialogRef<DialogAlertComponent>,
    @Inject(DIALOG_DATA) public data: DialogAlert
  ) {}

  ngOnInit() {}

  close(): void {
    this.dialogRef.close();
  }
}
